import api from '../token';

export const AbrirTurno = async (dados) => {
  try {
    const response = await api.post('/abrirTurno', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};